import { FC } from 'react';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectDocument } from 'app/store/DMSDocuments/DMSDocuments.selectors';
// Mui
import { Box, Paper } from '@mui/material';
// Compoentns
import { Loader } from 'app/components/Utilities';
// Hooks
import useHTMLLinkClickHandler from '../AIChatPage/MessageListItems/useHTMLLinkClickHandler';

const DocumentPreview:FC = () => {
  // Selectors
  const document = useAppSelector(selectDocument);

  const { containerRef } = useHTMLLinkClickHandler();

  if ( !document ) return <Loader />;
  return (
    <Box sx={{
      width: '100%',
      maxWidth: 816
    }}>
      <Paper elevation={2}
        ref={containerRef}
        sx={{
          height: 'initial',
          overflow: 'initial',
          borderRadius: 2,
          py: '19.2px',
          pl: '60.48px',
          pr: '36.48px',
          'whiteSpace': 'break-spaces'
        }}
        className="ql-editor preview"
        component="div"
        dangerouslySetInnerHTML={{ __html: document?.content || '' }}
      />
    </Box>
  )
}

export default DocumentPreview;